/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Portal API Gateway
 * OpenAPI spec version: 2.0.0
 */
import {
  useMutation,
  useQuery,
  type DataTag,
  type MutationFunction,
  type QueryClient,
  type QueryFunction,
  type QueryKey,
  type UseMutationOptions,
  type UseMutationReturnType,
  type UseQueryOptions,
  type UseQueryReturnType,
} from "@tanstack/vue-query"
import { computed, toValue, unref, type MaybeRefOrGetter } from "vue"

import { customInstance, type ErrorType } from ".././client.ts"
import { useMutationOptions } from ".././mutationOptions.ts"
import { useQueryOptions } from ".././queryOptions.ts"
import type {
  CancelSwitchReasonsRequest,
  CancelSwitchRequest,
  ChangeOfTenancyMoveInRequest,
  ChangeOfTenancyMoveWithUsRequest,
  Error,
  MoveWithUsChangeOfTenancy,
  MoveWithUsConstraintsResponse,
  SubmitMoveWithUsResponse,
  UpdateMoveWithUsMoveInDateRequest,
} from "../model"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Cancels the meter switches of the account
 */
export const cancelSwitchV2 = (
  accountId: MaybeRefOrGetter<number>,
  cancelSwitchRequest: MaybeRefOrGetter<CancelSwitchRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  accountId = toValue(accountId)
  cancelSwitchRequest = toValue(cancelSwitchRequest)

  return customInstance<void>(
    {
      url: `/api/v2/accounts/${accountId}/cancelSwitch`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: cancelSwitchRequest,
      signal,
    },
    options,
  )
}

export const useCancelSwitchV2MutationOptions = <
  TError = ErrorType<Error>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelSwitchV2>>,
    TError,
    { accountId: number; data: CancelSwitchRequest },
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelSwitchV2>>,
  TError,
  { accountId: number; data: CancelSwitchRequest },
  TContext
> => {
  const mutationKey = ["cancelSwitchV2"]
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelSwitchV2>>,
    { accountId: number; data: CancelSwitchRequest }
  > = (props) => {
    const { accountId, data } = props ?? {}

    return cancelSwitchV2(accountId, data, requestOptions)
  }

  const customOptions = useMutationOptions({ ...mutationOptions, mutationFn })

  return customOptions
}

export type CancelSwitchV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelSwitchV2>>
>
export type CancelSwitchV2MutationBody = CancelSwitchRequest
export type CancelSwitchV2MutationError = ErrorType<Error>

/**
 * @summary Cancels the meter switches of the account
 */
export const useCancelSwitchV2 = <
  TError = ErrorType<Error>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof cancelSwitchV2>>,
      TError,
      { accountId: number; data: CancelSwitchRequest },
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof cancelSwitchV2>>,
  TError,
  { accountId: number; data: CancelSwitchRequest },
  TContext
> => {
  return useMutation(useCancelSwitchV2MutationOptions(options), queryClient)
}
/**
 * @summary Save cancellation reasons per meter point
 */
export const cancelSwitchReasons = (
  accountId: MaybeRefOrGetter<number>,
  cancelSwitchReasonsRequest: MaybeRefOrGetter<CancelSwitchReasonsRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  accountId = toValue(accountId)
  cancelSwitchReasonsRequest = toValue(cancelSwitchReasonsRequest)

  return customInstance<void>(
    {
      url: `/api/v1/accounts/${accountId}/cancellationReason`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: cancelSwitchReasonsRequest,
      signal,
    },
    options,
  )
}

export const useCancelSwitchReasonsMutationOptions = <
  TError = ErrorType<Error>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelSwitchReasons>>,
    TError,
    { accountId: number; data: CancelSwitchReasonsRequest },
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelSwitchReasons>>,
  TError,
  { accountId: number; data: CancelSwitchReasonsRequest },
  TContext
> => {
  const mutationKey = ["cancelSwitchReasons"]
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelSwitchReasons>>,
    { accountId: number; data: CancelSwitchReasonsRequest }
  > = (props) => {
    const { accountId, data } = props ?? {}

    return cancelSwitchReasons(accountId, data, requestOptions)
  }

  const customOptions = useMutationOptions({ ...mutationOptions, mutationFn })

  return customOptions
}

export type CancelSwitchReasonsMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelSwitchReasons>>
>
export type CancelSwitchReasonsMutationBody = CancelSwitchReasonsRequest
export type CancelSwitchReasonsMutationError = ErrorType<Error>

/**
 * @summary Save cancellation reasons per meter point
 */
export const useCancelSwitchReasons = <
  TError = ErrorType<Error>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof cancelSwitchReasons>>,
      TError,
      { accountId: number; data: CancelSwitchReasonsRequest },
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof cancelSwitchReasons>>,
  TError,
  { accountId: number; data: CancelSwitchReasonsRequest },
  TContext
> => {
  return useMutation(
    useCancelSwitchReasonsMutationOptions(options),
    queryClient,
  )
}
/**
 * change of tenancy move-with-us (customer takes So Energy to a new property). When the request carries old-property closure details (forwarding address and last date of responsibility) and that account is already moving out - a move-out sent to the energy supplier system whose last date of responsibility has not passed, or an account end date there that has not passed (a move-out raised in the supplier system directly) - the submit is refused with 400 and errorCode cotMoveWithUsMoveOutAlreadyExists and nothing is recorded (SO-34036). The existing move-out stands; the customer does not need to request it again.
 * @summary Submit a Move-With-Us change of tenancy
 */
export const submitChangeOfTenancyMoveWithUs = (
  accountId: MaybeRefOrGetter<number>,
  changeOfTenancyMoveWithUsRequest: MaybeRefOrGetter<ChangeOfTenancyMoveWithUsRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  accountId = toValue(accountId)
  changeOfTenancyMoveWithUsRequest = toValue(changeOfTenancyMoveWithUsRequest)

  return customInstance<SubmitMoveWithUsResponse>(
    {
      url: `/api/v1/accounts/${accountId}/changeOfTenancy/moveWithUs`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: changeOfTenancyMoveWithUsRequest,
      signal,
    },
    options,
  )
}

export const useSubmitChangeOfTenancyMoveWithUsMutationOptions = <
  TError = ErrorType<Error>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitChangeOfTenancyMoveWithUs>>,
    TError,
    { accountId: number; data: ChangeOfTenancyMoveWithUsRequest },
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitChangeOfTenancyMoveWithUs>>,
  TError,
  { accountId: number; data: ChangeOfTenancyMoveWithUsRequest },
  TContext
> => {
  const mutationKey = ["submitChangeOfTenancyMoveWithUs"]
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitChangeOfTenancyMoveWithUs>>,
    { accountId: number; data: ChangeOfTenancyMoveWithUsRequest }
  > = (props) => {
    const { accountId, data } = props ?? {}

    return submitChangeOfTenancyMoveWithUs(accountId, data, requestOptions)
  }

  const customOptions = useMutationOptions({ ...mutationOptions, mutationFn })

  return customOptions
}

export type SubmitChangeOfTenancyMoveWithUsMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitChangeOfTenancyMoveWithUs>>
>
export type SubmitChangeOfTenancyMoveWithUsMutationBody =
  ChangeOfTenancyMoveWithUsRequest
export type SubmitChangeOfTenancyMoveWithUsMutationError = ErrorType<Error>

/**
 * @summary Submit a Move-With-Us change of tenancy
 */
export const useSubmitChangeOfTenancyMoveWithUs = <
  TError = ErrorType<Error>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof submitChangeOfTenancyMoveWithUs>>,
      TError,
      { accountId: number; data: ChangeOfTenancyMoveWithUsRequest },
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof submitChangeOfTenancyMoveWithUs>>,
  TError,
  { accountId: number; data: ChangeOfTenancyMoveWithUsRequest },
  TContext
> => {
  return useMutation(
    useSubmitChangeOfTenancyMoveWithUsMutationOptions(options),
    queryClient,
  )
}
/**
 * get the Move-With-Us change of tenancy for a billing account
 * @summary Get a Move-With-Us change of tenancy
 */
export const getChangeOfTenancyMoveWithUs = (
  accountId: MaybeRefOrGetter<number>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  accountId = toValue(accountId)

  return customInstance<MoveWithUsChangeOfTenancy>(
    {
      url: `/api/v1/accounts/${accountId}/changeOfTenancy/moveWithUs`,
      method: "GET",
      signal,
    },
    options,
  )
}

export const getGetChangeOfTenancyMoveWithUsQueryKey = (
  accountId: MaybeRefOrGetter<number>,
) => {
  return [
    "api",
    "v1",
    "accounts",
    accountId,
    "changeOfTenancy",
    "moveWithUs",
  ] as const
}

export const useGetChangeOfTenancyMoveWithUsQueryOptions = <
  TData = Awaited<ReturnType<typeof getChangeOfTenancyMoveWithUs>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getChangeOfTenancyMoveWithUs>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = getGetChangeOfTenancyMoveWithUsQueryKey(accountId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getChangeOfTenancyMoveWithUs>>
  > = ({ signal }) =>
    getChangeOfTenancyMoveWithUs(accountId, requestOptions, signal)

  const customOptions = useQueryOptions(
    {
      queryKey,
      queryFn,
      enabled: computed(
        () => toValue(accountId) !== null && toValue(accountId) !== undefined,
      ),
      ...queryOptions,
    },
    { accountId },
  )

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof getChangeOfTenancyMoveWithUs>>,
    TError,
    TData
  >
}

export type GetChangeOfTenancyMoveWithUsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getChangeOfTenancyMoveWithUs>>
>
export type GetChangeOfTenancyMoveWithUsQueryError = ErrorType<Error>

/**
 * @summary Get a Move-With-Us change of tenancy
 */

export function useGetChangeOfTenancyMoveWithUs<
  TData = Awaited<ReturnType<typeof getChangeOfTenancyMoveWithUs>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getChangeOfTenancyMoveWithUs>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>
} {
  const queryOptions = useGetChangeOfTenancyMoveWithUsQueryOptions(
    accountId,
    options,
  )

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >

  return query
}

/**
 * cancel the Move-With-Us change of tenancy for a billing account. Refused with 400 and errorCode cotMoveWithUsCancelTooLate once the old property's move-out has been sent to the energy supplier system, or may have been (SO-33593): the journey is left unchanged and back office is alerted to contact the customer where possible. The customer cannot self-serve past that point.
 * @summary Cancel a Move-With-Us change of tenancy
 */
export const cancelChangeOfTenancyMoveWithUs = (
  accountId: MaybeRefOrGetter<number>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  accountId = toValue(accountId)

  return customInstance<void>(
    {
      url: `/api/v1/accounts/${accountId}/changeOfTenancy/moveWithUs`,
      method: "DELETE",
      signal,
    },
    options,
  )
}

export const useCancelChangeOfTenancyMoveWithUsMutationOptions = <
  TError = ErrorType<Error>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelChangeOfTenancyMoveWithUs>>,
    TError,
    { accountId: number },
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelChangeOfTenancyMoveWithUs>>,
  TError,
  { accountId: number },
  TContext
> => {
  const mutationKey = ["cancelChangeOfTenancyMoveWithUs"]
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelChangeOfTenancyMoveWithUs>>,
    { accountId: number }
  > = (props) => {
    const { accountId } = props ?? {}

    return cancelChangeOfTenancyMoveWithUs(accountId, requestOptions)
  }

  const customOptions = useMutationOptions({ ...mutationOptions, mutationFn })

  return customOptions
}

export type CancelChangeOfTenancyMoveWithUsMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelChangeOfTenancyMoveWithUs>>
>

export type CancelChangeOfTenancyMoveWithUsMutationError = ErrorType<Error>

/**
 * @summary Cancel a Move-With-Us change of tenancy
 */
export const useCancelChangeOfTenancyMoveWithUs = <
  TError = ErrorType<Error>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof cancelChangeOfTenancyMoveWithUs>>,
      TError,
      { accountId: number },
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof cancelChangeOfTenancyMoveWithUs>>,
  TError,
  { accountId: number },
  TContext
> => {
  return useMutation(
    useCancelChangeOfTenancyMoveWithUsMutationOptions(options),
    queryClient,
  )
}
/**
 * amend the move-in date of a Move-With-Us change of tenancy
 * @summary Amend the move-in date of a Move-With-Us change of tenancy
 */
export const amendChangeOfTenancyMoveWithUsMoveInDate = (
  accountId: MaybeRefOrGetter<number>,
  updateMoveWithUsMoveInDateRequest: MaybeRefOrGetter<UpdateMoveWithUsMoveInDateRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  accountId = toValue(accountId)
  updateMoveWithUsMoveInDateRequest = toValue(updateMoveWithUsMoveInDateRequest)

  return customInstance<void>(
    {
      url: `/api/v1/accounts/${accountId}/changeOfTenancy/moveWithUs`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateMoveWithUsMoveInDateRequest,
      signal,
    },
    options,
  )
}

export const useAmendChangeOfTenancyMoveWithUsMoveInDateMutationOptions = <
  TError = ErrorType<Error>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof amendChangeOfTenancyMoveWithUsMoveInDate>>,
    TError,
    { accountId: number; data: UpdateMoveWithUsMoveInDateRequest },
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof amendChangeOfTenancyMoveWithUsMoveInDate>>,
  TError,
  { accountId: number; data: UpdateMoveWithUsMoveInDateRequest },
  TContext
> => {
  const mutationKey = ["amendChangeOfTenancyMoveWithUsMoveInDate"]
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof amendChangeOfTenancyMoveWithUsMoveInDate>>,
    { accountId: number; data: UpdateMoveWithUsMoveInDateRequest }
  > = (props) => {
    const { accountId, data } = props ?? {}

    return amendChangeOfTenancyMoveWithUsMoveInDate(
      accountId,
      data,
      requestOptions,
    )
  }

  const customOptions = useMutationOptions({ ...mutationOptions, mutationFn })

  return customOptions
}

export type AmendChangeOfTenancyMoveWithUsMoveInDateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof amendChangeOfTenancyMoveWithUsMoveInDate>>
  >
export type AmendChangeOfTenancyMoveWithUsMoveInDateMutationBody =
  UpdateMoveWithUsMoveInDateRequest
export type AmendChangeOfTenancyMoveWithUsMoveInDateMutationError =
  ErrorType<Error>

/**
 * @summary Amend the move-in date of a Move-With-Us change of tenancy
 */
export const useAmendChangeOfTenancyMoveWithUsMoveInDate = <
  TError = ErrorType<Error>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof amendChangeOfTenancyMoveWithUsMoveInDate>>,
      TError,
      { accountId: number; data: UpdateMoveWithUsMoveInDateRequest },
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof amendChangeOfTenancyMoveWithUsMoveInDate>>,
  TError,
  { accountId: number; data: UpdateMoveWithUsMoveInDateRequest },
  TContext
> => {
  return useMutation(
    useAmendChangeOfTenancyMoveWithUsMoveInDateMutationOptions(options),
    queryClient,
  )
}
/**
 * server-owned move-in date bounds for the Move-With-Us date picker (global; not account-specific)
 * @summary Get the valid Move-With-Us move-in date range for the date picker
 */
export const getChangeOfTenancyMoveWithUsConstraints = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<MoveWithUsConstraintsResponse>(
    {
      url: `/api/v1/changeOfTenancy/moveWithUs/constraints`,
      method: "GET",
      signal,
    },
    options,
  )
}

export const getGetChangeOfTenancyMoveWithUsConstraintsQueryKey = () => {
  return ["api", "v1", "changeOfTenancy", "moveWithUs", "constraints"] as const
}

export const useGetChangeOfTenancyMoveWithUsConstraintsQueryOptions = <
  TData = Awaited<ReturnType<typeof getChangeOfTenancyMoveWithUsConstraints>>,
  TError = ErrorType<Error>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getChangeOfTenancyMoveWithUsConstraints>>,
      TError,
      TData
    >
  >
  request?: SecondParameter<typeof customInstance>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = getGetChangeOfTenancyMoveWithUsConstraintsQueryKey()

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getChangeOfTenancyMoveWithUsConstraints>>
  > = ({ signal }) =>
    getChangeOfTenancyMoveWithUsConstraints(requestOptions, signal)

  const customOptions = useQueryOptions(
    { queryKey, queryFn, ...queryOptions },
    {},
  )

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof getChangeOfTenancyMoveWithUsConstraints>>,
    TError,
    TData
  >
}

export type GetChangeOfTenancyMoveWithUsConstraintsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getChangeOfTenancyMoveWithUsConstraints>>
>
export type GetChangeOfTenancyMoveWithUsConstraintsQueryError = ErrorType<Error>

/**
 * @summary Get the valid Move-With-Us move-in date range for the date picker
 */

export function useGetChangeOfTenancyMoveWithUsConstraints<
  TData = Awaited<ReturnType<typeof getChangeOfTenancyMoveWithUsConstraints>>,
  TError = ErrorType<Error>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getChangeOfTenancyMoveWithUsConstraints>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>
} {
  const queryOptions =
    useGetChangeOfTenancyMoveWithUsConstraintsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >

  return query
}

/**
 * change of tenancy move in
 * @summary Submit a request for change of tenancy move-in
 */
export const submitChangeOfTenancyMoveIn = (
  changeOfTenancyMoveInRequest: MaybeRefOrGetter<ChangeOfTenancyMoveInRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  changeOfTenancyMoveInRequest = toValue(changeOfTenancyMoveInRequest)

  return customInstance<void>(
    {
      url: `/api/v1/change-of-tenancy/move-in`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: changeOfTenancyMoveInRequest,
      signal,
    },
    options,
  )
}

export const useSubmitChangeOfTenancyMoveInMutationOptions = <
  TError = ErrorType<Error>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitChangeOfTenancyMoveIn>>,
    TError,
    { data: ChangeOfTenancyMoveInRequest },
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitChangeOfTenancyMoveIn>>,
  TError,
  { data: ChangeOfTenancyMoveInRequest },
  TContext
> => {
  const mutationKey = ["submitChangeOfTenancyMoveIn"]
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitChangeOfTenancyMoveIn>>,
    { data: ChangeOfTenancyMoveInRequest }
  > = (props) => {
    const { data } = props ?? {}

    return submitChangeOfTenancyMoveIn(data, requestOptions)
  }

  const customOptions = useMutationOptions({ ...mutationOptions, mutationFn })

  return customOptions
}

export type SubmitChangeOfTenancyMoveInMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitChangeOfTenancyMoveIn>>
>
export type SubmitChangeOfTenancyMoveInMutationBody =
  ChangeOfTenancyMoveInRequest
export type SubmitChangeOfTenancyMoveInMutationError = ErrorType<Error>

/**
 * @summary Submit a request for change of tenancy move-in
 */
export const useSubmitChangeOfTenancyMoveIn = <
  TError = ErrorType<Error>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof submitChangeOfTenancyMoveIn>>,
      TError,
      { data: ChangeOfTenancyMoveInRequest },
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof submitChangeOfTenancyMoveIn>>,
  TError,
  { data: ChangeOfTenancyMoveInRequest },
  TContext
> => {
  return useMutation(
    useSubmitChangeOfTenancyMoveInMutationOptions(options),
    queryClient,
  )
}
